import { render, staticRenderFns } from "./data45.vue?vue&type=template&id=c4dce2d8&scoped=true&"
import script from "./data45.vue?vue&type=script&lang=js&"
export * from "./data45.vue?vue&type=script&lang=js&"
import style1 from "./data45.vue?vue&type=style&index=1&id=c4dce2d8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4dce2d8",
  null
  
)

export default component.exports